.notesContainer {
	display: flex;
	flex-basis: 100%;
	height: 78%;
	overflow: auto;
	justify-content: center;
}

.sideBarContentNotes {
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 2px;
	flex-grow: 1;
}

.sideBarNotesInput {
	display: flex;
	flex-basis: 100%;
	padding: 20px;
}

.sideBarNotesTextareaButton {
	right: 8px;
	width: 28px;
	height: 28px;
	display: flex;
	place-content: center;
	align-items: center;
	padding: 0;
	border: 0;
	background: none;
	margin-right: 8px;

	&:focus-visible {
		outline: 2px solid var(--focus-outline-color-dark);
		outline-offset: 2px;
		border-radius: 8px;
	}
}

.roomScanNotesPanel {
	height: 80%;
	margin-top: 10px;
	flex-wrap: wrap;
	align-content: flex-start;
}

.roomScanNotesContainer {
	height: 68vh;
	display: flex;
	flex-direction: column;
	gap: 14px;
	padding: 14px 20px 20px 20px;
}

.roomScanNotesHeader {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 40px;
}

.roomScanNotesIcon {
	display: flex;
}

.roomScanNotesTitle:global(.MuiTypography-root) {
	font-size: 16px;
	margin-left: 10px;
	font-weight: 600;
}

.roomScanNotesWrapper {
	display: flex;
	width: 100%;
	height: 100%;
	border: 1px solid #e6e0e9;
	border-radius: 10px;
	flex-direction: column;
	justify-content: space-between;
}

.roomScanNotesInput {
	flex-basis: unset;
}
